<div class="login-form-content m-auto" *ngIf='maintenance==1'>
  <h4 class="text-center form-heading"> {{'Application is in Maintenance Mode. Please try after some time.'|translate}}</h4>
    <div class="mt-3">
      <button type="button" (click)="refresh()"
      class="btn btn-primary d-block w-100 text-uppercase text-white font-weight-bold">
      {{"Refresh"}}
    </button>
    </div>
</div>
<div class="login-form-content" *ngIf='maintenance==0 && !is2FAEnable'>
  <form class="login-form m-auto" ngForm [formGroup]="loginForm" (ngSubmit)="onSubmit($event)" novalidate>
    <h4 class="text-center mb-5 form-heading">{{"Login"|translate}}</h4>
    <div class="field-group mb-3">
      <label>{{"Email"|translate}}</label>
      <!-- <input type="text" formControlName="email"  autocomplete="new-password" [readonly]="userEmail" class="form-control" value="" />
       -->
       <input type="text" formControlName="email"  autocomplete="new-password"  class="form-control" value="" />

      <ng-container *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.required">
          <small class="form-error text-danger">
              {{"Please enter email"|translate}}.
          </small>
      </ng-container>
      <ng-container *ngIf="loginForm.controls.email && loginForm.controls.email.errors?.email">
        <small class="form-error text-danger">
              {{"Email address not well formed"|translate}}.
        </small>
    </ng-container>
    </div>
    <div class="field-group mb-3 mt-2">
      <label>{{"Password"|translate}}</label>
      <input type="password"  autocomplete="new-password" formControlName="password" class="form-control" value="" />
      <ng-container *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required">
          <small class="form-error text-danger">
              {{"Please enter password"|translate}}.
          </small>
      </ng-container>
    </div>

    <div class="mt-3">
      <button
      [disabled]="submitted"
        class="btn btn-primary d-block w-100 text-uppercase text-white font-weight-bold">
        {{"Login"|translate}}
      </button>
    </div>
    <div class="text-center font-size-14 mt-3" *ngIf="!isLoginAsClient">
      <a (click)="forgotPassword()" class="text-underline">{{"Forgot my password"|translate}}</a>  
    </div>

  </form>
</div>
<div class="login-form-content" *ngIf='maintenance==0 && is2FAEnable'>
  <form class="login-form m-auto" ngForm [formGroup]="twoFAForm" (ngSubmit)="on2FASubmit($event)" novalidate>
    <ng-container *ngIf="(authData?.auth_data?.opt_in_status=='SUBSCRIBED' && authData?.user?.mfa_type=='SMS') || authData?.user?.mfa_type=='APP'">
      <h4 class="text-center mb-3 form-heading" *ngIf="authData?.user?.mfa_type!='APP' || 
        authData?.user?.twofa_code=='YES'">
        {{"Two-Factor Authentication"|translate}}
      </h4>
      <ng-container *ngIf="authData?.user?.mfa_type=='APP' && authData?.user?.twofa_code=='NO' && 
          authData?.auth_data?.QRcode">
        <h4 class="text-center mb-3 form-heading" >{{"Register Two-Factor Authenticator"|translate}}</h4>
        <p class="mb-2">
          {{"Install one time password authenticator like Google or Microsoft Authenticator on your mobile device and use that app to scan this QR code.More information is available in the"|translate}} <a [routerLink]="['/', clientId, 'two-step-verification']" target="_blank">{{"documentation"|translate}}.</a>
        </p>
        <div [innerHTML]="authData.auth_data.QRcode" class="text-center"></div>
      </ng-container>
      <p *ngIf="authData?.user?.mfa_type=='APP' && authData?.user?.twofa_code=='YES'" >
        {{'Enter the code from your two-factor authenticator app'|translate}}.
      </p>
      <p *ngIf="authData?.user?.mfa_type=='SMS'" >
        {{'Please enter verification code sent to your mobile number'|translate}} {{authData?.user?.masked_mobile_number}}.
      </p>
      <div class="field-group mb-3 mt-4">
        <label>{{"Verification Code"|translate}}</label>
        <ng-otp-input formControlName="code" [config]="config" class="relogin-otp"></ng-otp-input>
        <div class="text-muted" *ngIf="authData?.user?.mfa_type!='APP'">
          <small *ngIf="iscountDown">
            {{"Didn't get the OTP?"|translate}} {{ "Resend in" | translate }} {{ counter }}s
          </small>
          <a href="javascript:void(0)" *ngIf="!iscountDown" (click)="onResendCode()">
            <small>{{ "Resend OTP" | translate }}</small>
          </a>
        </div>
      </div>
      <div class="mt-3">
      <button [disabled]="submitted || twoFAForm.controls.code.value?.length!=6" class="btn btn-primary d-block w-100 text-uppercase text-white font-weight-bold">
          {{((authData?.user?.mfa_type=='APP' && authData?.user?.twofa_code=='NO' && 
          authData?.auth_data?.QRcode) ? "Register for two-factor" : "Verify Code") | translate}}
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="!authData?.auth_data?.opt_in_status && authData?.user?.mfa_type=='SMS'">
      <h4 class="text-center mb-3 form-heading">
        {{"Subscribe mobile number"|translate}}
      </h4>
      <p>
        {{'Please enter verification code sent to your mobile number'|translate}} {{ authData?.user?.masked_mobile_number}} {{'to subscribe'|translate}}.
      </p>
      <div class="field-group mb-3 mt-3">
        <label>{{"Verification Code"|translate}}</label>
        <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="config" class="relogin-otp"></ng-otp-input>
        <div class="text-muted">
          <small *ngIf="iscountDown">
            {{"Didn't get the OTP?"|translate}} {{ "Resend in" | translate }} {{ counter }}s
          </small>
          <a href="javascript:void(0)" *ngIf="!iscountDown" (click)="onResendCode('subscribedMobile')">
            <small>{{ "Resend OTP" | translate }}</small>
          </a>
        </div>
      </div>
      <div class="mt-3">
        <button [disabled]="submitted || mobileSubscriptionOTP?.length!=6" class="btn btn-primary d-block w-100 text-uppercase text-white font-weight-bold" (click)="verifySubscribedMobileCode()">
          {{"Verify Code" | translate}}
        </button>
      </div>
    </ng-container>
  </form>
</div>
